<script>
  import Pane from "$lib/Elements/Pane.svelte";
  import { definitions, features, jobs } from "../store";
  import InputWrapper from "./InputWrapper.svelte";
  import { persisted } from "$lib/utils/persisted-stores";

  let workflow;
  export let context;
  export { workflow as definition };
  export let isReadonly;

  let properties = workflow.properties;
  let currentJob = jobs.currentJob;
  $: sidecarRead = features.sidecarRead;

  const additionalHelp = persisted("show_additional_help", true);
  $: showAdditionalHelp = $additionalHelp;

  function onPropertyChanged(property, value) {
    properties[property] = value;
    context.notifyPropertiesChanged();
  }

  function shouldDisplayProperty(property) {
    return property !== "global_context";
  }

  function jobInfo({ status, app }) {
    return { status, app };
  }
</script>

{#if $currentJob}
  <Pane class="p-4 mb-4">
    <h3 class="font-semibold text-sm text-content-subtle pb-5">Job {$currentJob.id}</h3>

    <div class="font-semibold mb-4">{$currentJob.device}</div>

    <div class="grid grid-cols-2 gap-y-1">
      {#each Object.entries(jobInfo($currentJob)) as [key, value] (key)}
        <div class="capitalize">{key}</div>
        <div class="font-semibold">{value}</div>
      {/each}
    </div>

    <div class="mt-4 flex flex-col gap-1">
      {#if $currentJob.batch_id}
        <a
          href="/app/batch/{$currentJob.batch_id}/results/{$currentJob.id}"
          target="_blank"
          class="text-blue-600 hover:text-blue-800 hover:underline"
        >
          View result
        </a>
      {/if}
      {#if $sidecarRead && $currentJob.sidecar_serial_number}
        <a
          href="/admin/sidecars/{$currentJob.sidecar_serial_number}"
          target="_blank"
          class="text-blue-600 hover:text-blue-800 hover:underline"
        >
          View sidecar ({$currentJob.sidecar_serial_number})
        </a>
      {/if}
    </div>
  </Pane>
{/if}

<Pane>
  <h3 class="font-semibold px-4 text-sm text-content-subtle pb-5">Workflow Settings</h3>

  <div class="px-3 mb-4">
    <h4 class="font-semibold mb-4">Properties</h4>
    {#each Object.entries(definitions.getRootDefinitions()) as [property, propertyType]}
      {#if shouldDisplayProperty(property)}
        <InputWrapper
          {properties}
          {property}
          {propertyType}
          {isReadonly}
          {showAdditionalHelp}
          step={{ id: null }}
          on:change={(e) => onPropertyChanged(property, e.detail)}
        />
      {/if}
    {/each}
  </div>
</Pane>
